import { GridFooterCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import { getBgColor } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';

const InvoiceAmountFooterCell = (props: GridFooterCellProps) => {
  const intl = useInternationalization();
  const totalAmount = useContextSelector(InvoiceContext, (value) => value.budgetPeriodsTotalAmount);
  const errorMessage = useContextSelector(InvoiceContext, (value) => value.errorMessage);
  return (
    <td className={getBgColor(errorMessage.totalAmount)}>
      <p className="text-right">{intl.format('{0:c2}', totalAmount)}</p>
    </td>
  );
};

export default InvoiceAmountFooterCell;
